module.exports = __webpack_public_path__ + "static/media/bitmojicomp.9f990676.JPG";